/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {backfillJoinedAt} from '../api'

export const useMutationBackfillJoinedAt = createReactQueryMutationHook('backfillJoinedAt', backfillJoinedAt)
